import { Reducer } from 'redux';

import { ILoaderActions, LOADER_ACTIONS } from './actions';

export interface ILoaderStore {
  show: boolean;
}

export const initialState: ILoaderStore = {
  show: false,
};

// --------------
// Reducer
// --------------

export const loaderReducer: Reducer<ILoaderStore, ILoaderActions> = (
  state: ILoaderStore = initialState,
  action: ILoaderActions
) => {
  switch (action.type) {
    case LOADER_ACTIONS.SHOW:
      return { ...state, show: true };
    case LOADER_ACTIONS.HIDE:
      return { ...state, show: false };

    default:
      return state;
  }
};
